<template>
  <div>
    <el-dialog title="选择司机" :visible.sync="showDialog" append-to-body width="40%" @close="onClose">
      <el-form :model="queryParams" inline size="mini" ref="driverFormRef">
        <el-form-item label="司机名称" prop="name">
          <el-input v-model="queryParams.name" clearable placeholder="请输入" style="width:120px" />
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="queryParams.mobile" clearable placeholder="请输入" style="width:120px" />
        </el-form-item>
        <el-button type="primary" @click="onQuery()" size="mini">查询</el-button>
        <el-button type="success" @click="onAdd()" size="mini">新增</el-button>
      </el-form>
      <plt-table ref="driverTableRef" :url="queryUrl" :queryParams="queryParams" paramName="param" size="mini" :pagination="false">
        <el-table-column label="司机名称" prop="name" :width="70" />
        <el-table-column label="手机号" prop="mobile" />
        <el-table-column label="身份证号" prop="identityNo" />
        <el-table-column label="车牌号" prop="plateNo" />
        <plt-table-dict-col label="车辆类型" namespace="logistic" id="vehicleType" prop="vehicleId" :width="80" />
        <el-table-column label="操作" :width="80" fixed="right">
          <template #default="{row}">
            <el-button type="text" @click="onSubmit(row)" size="mini">确定</el-button>
          </template>
        </el-table-column>
      </plt-table>
      <add-driver ref="addDriverRef" @onFinish="onFinish" />
    </el-dialog>
  </div>
</template>
<script>
import addDriver from "../../driver/component/add-driver.vue";

export default {
  components: { addDriver },
  data() {
    return {
      showDialog: false,
      queryParams: {
        carrierId: sessionStorage.getItem("memberId"),
        mobile: "",
        name: ""
      },
      queryUrl: "http://CORE-MEMBER/messageService/logisticsDriverService/queryLogisticsDriverDetailParam"
    };
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    onQuery() {
      this.$refs["driverTableRef"].loadFirstPage();
    },
    onFinish() {
      this.$refs["driverTableRef"].queryData();
    },
    onAdd() {
      this.$refs["addDriverRef"].openDialog();
    },
    onClose() {
      this.showDialog = false;
      this.$refs["driverFormRef"].resetFields();
    },
    // 提交
    async onSubmit(row) {
      this.$emit("onCallback", row);
      this.onClose();
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table--small .el-table__cell {
  padding: 0px 0;
}
/deep/ .el-table--mini td,
.el-table--mini th {
  padding: 0px 0px !important;
}
/deep/ .el-dialog__body {
  padding: 10px 20px;
}
/deep/ .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 5px;
}
</style>